import { render, staticRenderFns } from "./UsersStatistic.vue?vue&type=template&id=e0f80472&"
import script from "./UsersStatistic.vue?vue&type=script&lang=js&"
export * from "./UsersStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports